import React, { useState } from 'react';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DeleteMemberDialog = ({ member, open, onClose, onSuccess }) => {
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    setDeleting(true);

    try {
      const token = localStorage.getItem('admin_token');
      await axios.delete(
        `${API}/admin/member/${member.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success('Member deleted successfully');
      onSuccess();
      onClose();
    } catch (error) {
      console.error('Error deleting member:', error);
      toast.error(error.response?.data?.detail || 'Failed to delete member');
    } finally {
      setDeleting(false);
    }
  };

  if (!member) return null;

  return (
    <AlertDialog open={open} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-xl font-serif text-black">
            Delete Member?
          </AlertDialogTitle>
          <AlertDialogDescription className="text-gray-600">
            Are you sure you want to delete <strong>{member.first_name} {member.last_name}</strong>?
            <br />
            <span className="text-sm">Email: {member.email}</span>
            <br />
            <br />
            This action will mark the member as deleted. This cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" onClick={onClose} disabled={deleting}>
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            disabled={deleting}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            {deleting ? 'Deleting...' : 'Delete Member'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteMemberDialog;